import { render, staticRenderFns } from "./deliveryEditModal.vue?vue&type=template&id=213d1b8a&scoped=true"
import script from "./deliveryEditModal.vue?vue&type=script&lang=js"
export * from "./deliveryEditModal.vue?vue&type=script&lang=js"
import style0 from "./deliveryEditModal.vue?vue&type=style&index=0&id=213d1b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d1b8a",
  null
  
)

export default component.exports